import React from "react";
import banner from "../assets/images/FixBanner.jpg";

const FixFamilyTravelLanding: React.FC = () => {
  return (
    <section className="relative w-full h-[500px] flex items-center justify-center text-center overflow-hidden">
      {/* Banner image */}
      <img
        src={banner} // replace with your actual path
        alt="Travel Banner"
        className="absolute inset-0 w-full h-full object-cover brightness-75"
      />

      {/* Text overlay */}
      <div className="relative z-10 px-6 md:px-12 lg:px-24 max-w-4xl">
        <h2 className="bg-black bg-opacity-20 rounded p-3  text-3xl md:text-4xl font-semibold text-white mb-4 font-akshar">
          The Fix
        </h2>
        <p className="text-lg md:text-xl bg-black bg-opacity-30 rounded p-3 leading-relaxed text-white font-poppins">
          At <strong className="text-blue-200">Travel N Relax</strong>, we
          handle every moving piece—flights, transfers, hotels, park passes,
          activities—so you can focus on what matters: connection, laughter,
          discovery. Whether you’re cruising with Mickey or exploring ancient
          castles, your family’s perfect trip starts here.
        </p>
      </div>
    </section>
  );
};

export default FixFamilyTravelLanding;
